import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 页面状态存储
 * 用于在标签页切换时保持各页面的选中项目状态
 */
export const usePageStateStore = defineStore('pageState', () => {
  // 存储各页面的选中项目ID，key为路由路径
  const selectedIds = ref<Record<string, string | number | null>>({})

  /**
   * 设置页面选中的项目ID
   * @param routePath 路由路径（作为页面唯一标识）
   * @param id 选中项目的ID
   */
  const setSelectedId = (routePath: string, id: string | number | null) => {
    selectedIds.value[routePath] = id
  }

  /**
   * 获取页面选中的项目ID
   * @param routePath 路由路径
   * @returns 选中项目的ID，不存在则返回null
   */
  const getSelectedId = (routePath: string): string | number | null => {
    return selectedIds.value[routePath] ?? null
  }

  /**
   * 清除页面选中状态
   * @param routePath 路由路径，不传则清除所有
   */
  const clearSelectedId = (routePath?: string) => {
    if (routePath) {
      delete selectedIds.value[routePath]
    } else {
      selectedIds.value = {}
    }
  }

  return {
    selectedIds,
    setSelectedId,
    getSelectedId,
    clearSelectedId
  }
})
